import {
  Configuration,
  LogLevel,
  PublicClientApplication,
} from "@azure/msal-browser";

// Determine the base URL based on the environment
const baseUrl = window.location.origin;

export const msalConfig: Configuration = {
  auth: {
    clientId: "f8eeb5e4-cb88-4571-86a6-72ad144aaf88",
    authority: "https://login.microsoftonline.com/common",
    redirectUri: baseUrl,
    postLogoutRedirectUri: baseUrl,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            break;
          case LogLevel.Verbose:
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
      logLevel: LogLevel.Info,
    },
  },
};
